import React, { useState } from "react";
import { supabase } from "../services/supabase";
import { useNavigate } from "react-router-dom";
import "../index.css"; // Pour utiliser les styles globaux

const LoginPage = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");

    try {
      // Auth Supabase
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) throw error;

      // Récupération du rôle dans profiles
      const { data: profile, error: profileError } = await supabase
        .from("profiles")
        .select("role")
        .eq("id", data.user.id)
        .single();

      if (profileError) throw profileError;

      if (!["admin", "collaborateur"].includes(profile.role)) {
        throw new Error("Accès refusé : vous n'êtes pas autorisé.");
      }

      // Redirection vers la partie admin
      navigate("/");
    } catch (err) {
      console.error("Erreur login:", err);
      setErrorMsg(err.message || "Erreur de connexion");
    }

    setLoading(false);
  };

  // Gérer le mot de passe oublié
/*
  const handleForgotPassword = async () => {
  if (!email) {
    alert("Veuillez entrer votre adresse email.");
    return;
  }

  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/reset-password`,
  });

  if (error) {
    alert(error.message);
    return;
  }

  alert("Un email de réinitialisation a été envoyé.");
};
*/

  return (
    <div className="login-container">
        

      <form className="login-card" onSubmit={handleLogin}>

        {/* LOGO */}
      <div className="login-logo">
        <img src="/Bel_taxi_logo.png" alt="Logo" />
      </div>
        <h2>Connexion</h2>

        {errorMsg && <div className="error-message">{errorMsg}</div>}

        <div className="form-row">
          <label>Email</label>
          <input
            type="email"
            placeholder="admin@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-row">
          <label>Mot de passe</label>
          <input
            type="password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button className="btn-primary" type="submit" disabled={loading}>
          {loading ? "Connexion..." : "Se connecter"}
        </button>

      </form>
    </div>
  );
};

export default LoginPage;
